export default "__VITE_ASSET__02FI9q80__"